import { CallState, LoadingState } from '@lcs/shared/api';
import { Action, createReducer, on } from '@ngrx/store';
import { onReset } from 'src/app/authentication/reset-reducer';
import * as AddScheduleActions from './add-schedule.actions';

export const addScheduleFeatureKey = 'addSchedule';

export interface AddScheduleState {
   callState: CallState;
}

export const initialState: AddScheduleState = {
   callState: LoadingState.Init,
};

const addScheduleReducer = createReducer(
   initialState,
   onReset(initialState),
   on(AddScheduleActions.createSchedule, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(AddScheduleActions.createScheduleSuccess, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   }),
   on(AddScheduleActions.createScheduleFailure, (state) => {
      return {
         ...state,
         callState: LoadingState.Loaded,
      };
   })
);

export function reducer(state: AddScheduleState | undefined, action: Action) {
   return addScheduleReducer(state, action);
}
